export const CANONICAL_LANGUAGE = 'de';

export const PRODUCTION_TRANSLATIONS = ['de', 'tr'] as const;

export const REVIEW_REQUIRED_LANGUAGES = [
  'ar', 'pl', 'uk', 'ru', 'sq', 'es', 'en', 'fa', 'id', 'fr', 'kmr', 'ro', 'bg', 'it', 'hr', 'sr', 'prs', 'bs', 'vi', 'hu', 'el'
];

export type ProductionLanguage = typeof PRODUCTION_TRANSLATIONS[number];

export function isProductionLanguage(lang: string): lang is ProductionLanguage {
  return (PRODUCTION_TRANSLATIONS as readonly string[]).includes(lang);
}

export function getInterfaceLanguages() {
  return [...PRODUCTION_TRANSLATIONS, ...REVIEW_REQUIRED_LANGUAGES];
}
